import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  useDisclosure,
  Text,
  Flex,
} from "@chakra-ui/react";
import { ExclamationCircleIcon } from "../../../styles/icons/ExclamationCircleIcon";

export function DiscardChangesModal({ resetTrigger, setResetTrigger, setOnEdit, onEdit }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleClick = () => {
    setResetTrigger(resetTrigger + 1)
    onClose();
    setOnEdit(false);
  };
  return (
    <>
      <Flex alignItems="center" gap="8px" >
        <Button onClick={onOpen} variant="outline" w="174" h="32px" cursor="pointer">
          <Text
            color="rgba(0, 0, 0, 0.85)"
            fontSize="14px"
            fontWeight="400"
          >
            Descartar mudanças
          </Text>
        </Button>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent
          mb="0"
          borderRadius="2px"
        >
          <Flex flexDirection="row" alignItems="flex-start" gap="16px" p="32px 24px 0 24px">
            <ExclamationCircleIcon />
            <Flex flexDirection="column" flex="1">
              <ModalHeader
                color="rgba(0, 0, 0, 0.85)"
                mb={2}
                p="0"
                fontSize="18px"
                lineHeight="22px"
              >
                Tem certeza que deseja descartar as mudanças?
              </ModalHeader>
              <ModalBody p="0">
                <Text
                  color="rgba(0, 0, 0, 0.85)"
                  fontSize="14px"
                  lineHeight="22px"
                >
                  As alterações que você fez agora serão perdidas.
                </Text>
              </ModalBody>
            </Flex>
          </Flex>

          <ModalFooter gap="12px" p="24px">
            <Button
              variant="outline"
              onClick={() => onClose()}
              fontSize="14px"
              fontWeight="400"
              fontFamily="Hero New"
              borderRadius="2px"
              h="32px">

              <Text
                color="rgba(0, 0, 0, 0.85)"
              >
                Cancelar

              </Text>
            </Button>
            <Button colorScheme="blue" onClick={
              handleClick
            } fontSize="14px"
              fontWeight="400"
              fontFamily="Hero New"
              borderRadius="2px"
              h="32px">
              Descartar mudanças
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
